import React from 'react';

const VARIANT_CLASSES = {
  label: 'text-xs text-gray-500 mb-1',
  title: 'text-3xl font-bold text-gray-900',
  subtitle: 'text-gray-500 mt-1',
  section: 'text-sm font-medium text-gray-700',
  heading: 'text-xl font-semibold mb-4',
  small: 'text-sm text-gray-600',
};

const UiText = ({ variant = 'label', as = 'div', className = '', children, ...rest }) => {
  const Tag = as;
  const base = VARIANT_CLASSES[variant] || VARIANT_CLASSES.label;
  return (
    <Tag className={`${base} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
};

export default UiText;
